import { apiService } from './apiService';

export const weighbridgePointService = {
  async getAll() {
    return await apiService.get('/weighbridge-points');
  },

  async getById(id: string | number) {
    return await apiService.get(`/weighbridge-points/${id}`);
  },

  async importBmsRoadInspectionStations() {
    return await apiService.post('/weighbridge-points/import-bms-road-inspection-stations');
  },

  async create(data: any) {
    return await apiService.post('/weighbridge-points', data);
  },

  async update(id: string | number, data: any) {
    return await apiService.put(`/weighbridge-points/${id}`, data);
  },

  async delete(id: string | number) {
    return await apiService.delete(`/weighbridge-points/${id}`);
  },

  async importExcel(rows: any[]) {
    return await apiService.post('/weighbridge-points/bulk-import', { rows });
  },
};
